import { HttpLoaderFactory } from './application/translation/httpLoaderFactory';
var ɵ0 = HttpLoaderFactory;
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
export { SharedModule };
export { ɵ0 };
